var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTable',{attrs:{"headers":_vm.headersWithCustomWidths,"rows":_vm.customRows,"caption":"User name, age, city, and joined date","sortable":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }